import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryList(params) {
  return request('/actionSetVariableMapping/paged', {
    params: toQuery(params),
  });
}

export async function queryEditItemSetVariable({ id, params }) {
  return request(`/actionSetVariableMapping/${id}`, {
    params: toQuery(params),
  });
}

export async function queryAddNewSetVariable(params) {
  return request.post(`/actionSetVariableMapping`, {
    data: params,
  });
}

export async function queryAddEditSetVariable(params) {
  return request.put('/actionSetVariableMapping', {
    data: params,
  });
}

export async function queryDeleteItem(id) {
  return request.delete(`/actionSetVariableMapping/${id}`, {});
}
